var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _g, _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyStateCloudSuppliers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 161,
    viewBox: "0 0 220 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 80.5,
    r: 80,
    fill: "#EAECF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 20.5,
    r: 8,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 126.5,
    r: 6,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 138.5,
    r: 10,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 46.5,
    r: 10,
    fill: "#F2F4F7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 11.5,
    r: 7,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3197_24162)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.486 16.5C96.7495 16.5 81.9448 24.7701 72.9354 37.4466C69.9934 36.7528 66.9253 36.3857 63.7714 36.3857C41.8063 36.3857 24 54.192 24 76.1571C24 98.1223 41.8063 115.929 63.7714 115.929H163.2C182.42 115.929 198 100.348 198 81.1286C198 61.9091 182.42 46.3286 163.2 46.3286C161.835 46.3286 160.488 46.4072 159.164 46.5601C151.546 28.8784 133.961 16.5 113.486 16.5Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.7714,
    cy: 76.1562,
    r: 39.7714,
    fill: "url(#paint0_linear_3197_24162)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.486,
    cy: 66.2143,
    r: 49.7143,
    fill: "url(#paint1_linear_3197_24162)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.2,
    cy: 81.1281,
    r: 34.8,
    fill: "url(#paint2_linear_3197_24162)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 84.5,
    width: 56,
    height: 56,
    rx: 12,
    fill: "#C2ECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.615 109.652C114.594 109.692 114.606 109.741 114.643 109.767L114.615 109.652ZM114.615 109.652L114.694 109.694L114.694 109.694L115.056 109.888C115.11 109.787 115.17 109.691 115.237 109.599M114.615 109.652L114.695 109.692L114.695 109.693L115.06 109.88C115.149 109.706 115.104 109.479 114.929 109.357C115.032 109.428 115.136 109.508 115.237 109.599M115.237 109.599C115.27 109.629 115.304 109.661 115.336 109.693L114.983 110.046L115.336 109.693L116.209 110.566C116.392 110.182 116.784 109.917 117.236 109.917H120.13C120.756 109.917 121.265 110.425 121.265 111.052V114.581V115.081H120.765H119.817V122.991C119.817 123.362 120.119 123.665 120.492 123.665C120.864 123.665 121.165 123.365 121.165 122.991V116.927V116.455L121.637 116.428C122.182 116.396 122.613 115.945 122.613 115.393V111.052C122.613 109.682 121.499 108.568 120.13 108.568H117.236C116.413 108.568 115.688 108.974 115.237 109.599ZM115.991 114.19L115.984 114.183L113.09 111.29C112.827 111.026 112.401 111.026 112.137 111.29L112.137 111.29C111.875 111.552 111.874 111.977 112.134 112.241L113.056 113.127L113.95 113.988H112.709H107.245H106.037L106.892 113.134L107.782 112.245C107.782 112.245 107.782 112.245 107.782 112.245C108.045 111.981 108.045 111.555 107.782 111.29C107.518 111.027 107.092 111.028 106.829 111.291L103.935 114.185C103.672 114.448 103.671 114.875 103.935 115.14L106.829 118.034L106.83 118.035C106.96 118.166 107.129 118.231 107.307 118.231C107.483 118.231 107.652 118.166 107.785 118.034C108.048 117.769 108.048 117.344 107.784 117.08C107.784 117.079 107.784 117.079 107.784 117.079L106.892 116.19L106.036 115.336H107.245H112.71H113.917L113.064 116.19L112.174 117.08C111.911 117.343 111.91 117.769 112.174 118.034C112.174 118.034 112.174 118.034 112.174 118.034M115.991 114.19L112.653 118.731C112.35 118.731 112.051 118.619 111.82 118.388L112.174 118.034M115.991 114.19L115.998 114.196C116.285 114.462 116.283 114.878 116.024 115.139C116.024 115.139 116.024 115.139 116.024 115.139L113.131 118.033C113.131 118.033 113.131 118.033 113.131 118.033M115.991 114.19L113.131 118.033M112.174 118.034C112.306 118.166 112.475 118.231 112.653 118.231C112.829 118.231 112.998 118.165 113.131 118.033M112.174 118.034L113.131 118.033M98.734 114.581V115.081H99.234H100.181V122.991C100.181 123.363 99.8784 123.665 99.507 123.665C99.1332 123.665 98.8322 123.365 98.8322 122.991L98.8322 122.988L98.7925 116.922L98.7894 116.456L98.3236 116.427C97.8242 116.396 97.3855 115.951 97.3855 115.393V111.052C97.3855 109.681 98.4966 108.568 99.8687 108.568H102.763C103.583 108.568 104.308 108.975 104.761 109.599C104.728 109.629 104.694 109.661 104.661 109.693L103.789 110.566C103.607 110.182 103.216 109.917 102.763 109.917H99.8687C99.2425 109.917 98.734 110.425 98.734 111.052V114.581ZM105.072 109.355L105.072 109.355L105.072 109.355ZM102.45 122.991V117.434L103.798 118.782V122.991C103.798 123.365 103.496 123.665 103.125 123.665C102.753 123.665 102.45 123.364 102.45 122.991ZM116.199 118.782L117.548 117.434V122.991C117.548 123.363 117.245 123.665 116.874 123.665C116.501 123.665 116.199 123.362 116.199 122.991V118.782ZM101.248 106.166C100.073 106.166 99.1227 105.216 99.1227 104.041C99.1227 102.866 100.072 101.916 101.248 101.916C102.424 101.916 103.373 102.866 103.373 104.041C103.373 105.216 102.423 106.166 101.248 106.166ZM118.776 106.166C117.6 106.166 116.651 105.216 116.651 104.041C116.651 102.866 117.6 101.916 118.776 101.916C119.951 101.916 120.901 102.866 120.901 104.041C120.901 105.216 119.951 106.166 118.776 106.166Z",
    fill: "#008C99",
    stroke: "#008C99"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3197_24162",
    x: 4,
    y: 16.5,
    width: 214,
    height: 139.428,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3197_24162"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3197_24162"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3197_24162"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3197_24162",
    result: "effect2_dropShadow_3197_24162"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3197_24162",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3197_24162",
    x1: 33.2326,
    y1: 49.8786,
    x2: 103.543,
    y2: 115.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3197_24162",
    x1: 75.3123,
    y1: 33.3673,
    x2: 163.2,
    y2: 115.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3197_24162",
    x1: 136.478,
    y1: 58.1353,
    x2: 198,
    y2: 115.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.350715,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateCloudSuppliers);
export default __webpack_public_path__ + "static/media/empty_state_cloud_suppliers.4de07ec0825cc3da397322dd6973de30.svg";
export { ForwardRef as ReactComponent };